function initCoddleProgressBar(progressWrapper) {
  const container = document.getElementById(progressWrapper);
  if (!container || !container.querySelector('.overflow-x-scroll')) {
    return;
  }
  const carousel = container.querySelector('.overflow-x-scroll');
  const navButtons = container.querySelectorAll('[data-progress-nav]');

  let isDragging = false;
  let startX = 0;
  let mousePosition = 0;
  let scrollLeft = 0;

  // Get the progress bar for this carousel
  const progressBar = container.querySelector('.js-progress-bar');

  // Function to update progress bar and button states
  const updateProgress = () => {
    if (!progressBar) return;
    const maxScroll = carousel.scrollWidth - carousel.clientWidth;
    let scrollPercentage = maxScroll > 0 ? (carousel.scrollLeft / maxScroll) * 100 : 0;
    if (scrollPercentage < 25) scrollPercentage = 25;
    progressBar.style.width = `${scrollPercentage}%`;
    
    updateButtonStates();
  };

  // Function to update navigation button states
  const updateButtonStates = () => {
    const maxScroll = carousel.scrollWidth - carousel.getBoundingClientRect().width;
    const currentScroll = carousel.scrollLeft;
    
    navButtons.forEach(button => {
      const direction = button.dataset.progressNav;
      
      if (direction === 'prev') {
        // Disable prev button if at the beginning
        button.disabled = currentScroll <= 0;
      } else if (direction === 'next') {
        // Disable next button if at the end
        button.disabled = currentScroll >= maxScroll;
      }
    });
  };

  // Navigation events
  navButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Don't scroll if button is disabled
      if (button.disabled) return;
      
      carousel.scrollBy({
        left: e.currentTarget.dataset.progressNav === 'prev' ? -carousel.offsetWidth : carousel.offsetWidth,
        behavior: 'smooth'
      });
    });
  });

  // Mouse events
  carousel.addEventListener('mousedown', (e) => {
    // Prevent default behavior of interactive elements
    e.preventDefault();
    isDragging = true;
    carousel.style.cursor = 'grabbing';
    carousel.style.userSelect = 'none';
    startX = e.pageX - carousel.offsetLeft;
    mousePosition = e.clientX;
    scrollLeft = carousel.scrollLeft;
  });

  carousel.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1; // Scroll speed multiplier
    carousel.scrollLeft = scrollLeft - walk;
    updateProgress();
  });

  carousel.addEventListener('click', (e) => {
    // Only prevent default for links if we were dragging
    if (isDragging && e.target.tagName === 'A') {
      e.preventDefault();
    }
  });

  carousel.addEventListener('mouseup', (e) => {
    e.preventDefault();
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
  });

  carousel.addEventListener('mouseleave', () => {
    isDragging = false;
    carousel.style.cursor = 'grab';
    carousel.style.userSelect = 'auto';
  });

  // Update progress on scroll events
  carousel.addEventListener('scroll', updateProgress);

  // Set initial cursor style and progress
  carousel.style.cursor = 'grab';
  updateProgress();
}

// Make function globally available
if (!window.initCoddleProgressBar) {
  window.initCoddleProgressBar = initCoddleProgressBar;
}